import { render, staticRenderFns } from "./nbn-table-actions.vue?vue&type=template&id=d64d4064&scoped=true"
import script from "./nbn-table-actions.vue?vue&type=script&lang=js"
export * from "./nbn-table-actions.vue?vue&type=script&lang=js"
import style0 from "./nbn-table-actions.vue?vue&type=style&index=0&id=d64d4064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64d4064",
  null
  
)

export default component.exports